export default "Systematische Übersicht zur wachsenden Studienlage von Yoga bei Prostatakrebs-Überlebenden."